import { render } from "./LighterElement.vue?vue&type=template&id=5c93f857&scoped=true"
import script from "./LighterElement.vue?vue&type=script&lang=js"
export * from "./LighterElement.vue?vue&type=script&lang=js"

import "./LighterElement.vue?vue&type=style&index=0&id=5c93f857&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c93f857"]])

export default __exports__